import { render, staticRenderFns } from "./TableModule.vue?vue&type=template&id=124da49b&scoped=true&"
import script from "./TableModule.vue?vue&type=script&lang=js&"
export * from "./TableModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124da49b",
  null
  
)

export default component.exports